var ENV_CONST = {
	canonicalUrl: "https://intltoursearch.jal.co.jp",
	jmbtourUrl: "jmbtour.jal.co.jp",
	dispatcherUrl: "https://sp5971.jal.co.jp/JmbSp/JR/Dispatcher_ja.do"
};

if (typeof module !== "undefined" && module.exports) {
	module.exports = ENV_CONST;
}



//////////////////
// WEBPACK FOOTER
// ./web/WEB-INF/script/env-const.js.prod
// module id = 11
// module chunks = 0 1 2